// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2Qhu1","header":"PatientQuestionnaire_header__nyCni","info":"PatientQuestionnaire_info__2VC9O"};